/*
 * Copyright (C) 2020 Adrien Fery. All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential.
 * 
 * This script allow to change the variant selector when a variant's thumbnail is clicked.
 */

(function()
{
  // Get all thumbnail elements.
  const thumbnailElements = Array.from(document.getElementsByClassName('product-single__thumbnail-image'));

  // Add click event listener on each thumbnail. 
  thumbnailElements.forEach((thumbnailElement) =>
  {
    thumbnailElement.addEventListener('click', (event) =>
    {
      const targetElement = event.target || event.srcElement;
      const variant = targetElement.getAttribute('data-variant');
      
        console.log('variant: ' + variant);

      if (variant)
      {
        selectVariant(variant);
      }
    }); 
  });

  function selectVariant(variant)
  {
    // Select the given variant option.
    let optionSelectorElements = document.getElementsByClassName('single-option-selector');
    for (let i = 0; i < optionSelectorElements.length; i++)
    {
      const labels = Array.from(optionSelectorElements[i].options).map(item => item.text);
      if (labels.indexOf(variant) >= 0)
      {
        optionSelectorElements[i].value = variant;
        optionSelectorElements[i].dispatchEvent(new Event('change'));
      }
    }
  }
}());
